import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import * as XLSX from "xlsx";
import {Project} from "../../interfaces/project";
import {ProjectService} from "../../services/project.service";
import {SchoolLocations} from "../../data/locations";
import { NgIf, NgForOf } from "@angular/common";

@Component({
  selector: 'app-generate-form',
  standalone: true,
  imports: [FormsModule, NgForOf, NgIf],
  templateUrl: './generate-form.component.html',
  styleUrl: './generate-form.component.css'
})
export class GenerateFormComponent implements OnInit {
  generateFormFlags = { showYear: true, showScope: false, showSelection: false };
  generateFormData = {
    selectedForm: 'food', schoolYear: '', scope: '', selection: [] as string[] | string,
    selectionLabel: '', selectionOptions: [] as string[]
  };
  projects: Project[] = [];

  constructor(private projectService: ProjectService) {}

  async ngOnInit() { this.projects = await this.projectService.getProjects(); }

  setFlagsForForm() {
    this.generateFormFlags.showYear = true;
    this.generateFormFlags.showScope = false;
    this.generateFormFlags.showSelection = false;
  }

  onFormChange() {
    this.setFlagsForForm();
    const data = this.generateFormData;

    data.schoolYear = '';
    data.scope = '';
    data.selection = '';
    data.selectionLabel = '';
    data.selectionOptions = [];

    if (data.selectedForm === 'food') this.generateFormFlags.showYear = true;
  }

  onYearChange() {
    const data = this.generateFormData;
    this.generateFormFlags.showScope = true;
    this.generateFormFlags.showSelection = false;
    data.scope = '';
    data.selection = '';
  }

  onScopeChange() {
    const data = this.generateFormData;
    const flags = this.generateFormFlags;
    flags.showSelection = false;

    if (data.selectedForm !== 'food') return;

    const scope = data.scope;
    if (scope === 'school') {
      flags.showSelection = true;
      data.selectionLabel = 'Select School';
      data.selectionOptions = this.getSchools();
      data.selection = '';
    } else if (scope === 'cluster') {
      flags.showSelection = true;
      data.selectionLabel = 'Select Cluster (select up to 2)';
      data.selectionOptions = this.getFoodAuditClusters();
      data.selection = [];
    } else if (scope === 'all') {
      flags.showSelection = false;
      data.selectionOptions = [];
      data.selection = this.getSchools();
    }
  }

  toggleCluster(cluster: string, event: any) {
    const selected = this.generateFormData.selection as string[];
    if (event.target.checked) {
      if (selected.length < 2) selected.push(cluster);
      else event.target.checked = false;
    } else {
      this.generateFormData.selection = selected.filter(c => c !== cluster);
    }
  }

  canGenerate(): boolean {
    const data = this.generateFormData;
    if (!data.selectedForm || !data.schoolYear || !data.scope) return false;
    if (data.scope === 'cluster' || data.scope === 'all') return Array.isArray(data.selection) && data.selection.length > 0;
    return !!data.selection;
  }

  generatePdf() {
    alert('PDF generated');
    console.log('Generate form selection:', this.generateFormData.selection);
  }

  hasFoodAudit(project: Project) {
    return project.fwasteaudit || !!project.foodAuditDate || !!project.foodAuditNumLunchesServed;
  }

  getFoodAuditYears(): string[] {
    return this.projects.filter(p => this.hasFoodAudit(p)).map(p => p.schoolYear).filter((v,i,a)=>a.indexOf(v)===i).sort();
  }

  getSchools(): string[] {
    if (!this.generateFormData.schoolYear) return [];
    return this.projects.filter(p => this.hasFoodAudit(p) && p.schoolYear === this.generateFormData.schoolYear).map(p => p.school).filter((v,i,a)=>a.indexOf(v)===i).sort();
  }

  getFoodAuditClusters(): string[] {
    if (!this.generateFormData.schoolYear) return [];
    const auditedSchools = this.projects.filter(p => this.hasFoodAudit(p) && p.schoolYear === this.generateFormData.schoolYear).map(p=>p.school);
    return SchoolLocations.filter(loc => auditedSchools.includes(loc.SchoolName)).map(loc => loc.Cluster).filter((v,i,a)=>a.indexOf(v)===i).sort();
  }

  protected readonly Array = Array;
}
